import { ArrowBackIcon } from 'assets/icons';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { Header } from 'components';
import IconButton from 'components/foundation/buttons/IconButton/IconButton';
import { FunctionComponent, ReactNode } from 'react';
import './OnboardingPage.scss';

export interface IOnboardingPageProps {
  onBackClick: () => void;
  hideBackClick?: boolean;
  children?: ReactNode;
  pager: ReactNode;
  className?: ClassName;
}

const OnboardingPage: FunctionComponent<IOnboardingPageProps> = (props) => {
  const { children, pager, onBackClick, hideBackClick, className } = props;

  const classes = classNames(
    {
      'onboarding-page': true,
    },
    className
  );

  return (
    <div className={classes}>
      <Header>{hideBackClick !== true && <IconButton svg={ArrowBackIcon} onClick={onBackClick} />}</Header>
      <div className={'onboarding-pager'}>{pager}</div>
      {children}
    </div>
  );
};

export default OnboardingPage;
